import './team-members.css';
import About1 from '../../../../assets/image/YUSUFF AWOSANYA.jpg';
import '../daytopia.css';
import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Sidebar from '../../../../Components/Sidebar/sidebar';
import '../../../../Components/Sidebar/sidebar.css';
import Navbar from '../../../../Components/Header/Navbar';
import Footer from '../../../../Components/Footer/Footer';
import '../../../../Components/Sidebar/sidebar.css';
import AdejumokeAwonsa from '../../../../assets/image/Dr. Adejumoke Awosanya.jpg';
import Breadcrumbs from './Breadcrumbs';

const TeamMember8 = () => {
    const [toggle, setToggle] = useState(false);
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    // Use onAuthStateChanged to listen for changes in user authentication
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserIsLoggedIn(true); // User is logged in
      } else {
        setUserIsLoggedIn(false); // User is not logged in
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, [auth]);


  function Toggle() {
    setToggle(!toggle);
  }

  useEffect(() => {
    const handleSize = () => {
    if(window.innerWidth > 768) {
      setToggle(false);
    }
}
    window.addEventListener('resize', handleSize);

    return () => {
      window.removeEventListener('resize', handleSize)
    }
  
  }, []) 
  return (
    <div className="d-flex">
    <div className={toggle ? "d-none" : "w-auto position-fixed"} >
    {userIsLoggedIn && <Sidebar />} 
    </div>

    <div className= {toggle ? "d-none" : "invisible"} >
    {userIsLoggedIn && <Sidebar />} 
    </div>

    <div className='col'>
    <Navbar Toggle={Toggle}/>
    <Breadcrumbs />
    <section id="work-process" className="work-process">
    <div className="container">

        <div className="section-title" data-aos="fade-up">
            <h2>About Our Mentor Dr. Adejumoke Awosanya (Co-Founder)</h2>
            <p className='founders-DP'></p>
        </div>

        <div className="row content">
            <div className="col-md-5" data-aos="fade-right">
                <img src={ AdejumokeAwonsa } className="img-fluid" alt="Adejumoke Awonsa" />
            </div>
            <div className="col-md-7 pt-4" data-aos="fade-left">
               
                <p>
                Proposed constitution of the Organisation.  Akay Obekpa is an IT professional who has gained over 5 years experience in Banking, Education and Technology sectors in the UK. Over the past years, his role as a student mentor at Birmingham city university, working closely with international students and home students has vastly increased his ability to work with students and professionals with an open mind to learn and grow. 
                </p>
                <p>
                As a mentor at Daytopia, Akay’s focus will be on Technology development (specifically API development & integration), finance(investments) and career development. Feel free to reach out!!
                </p>
              {/* <ul>
                    <li><i className="bi bi-check"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </li>
                    <li><i className="bi bi-check"></i> Duis aute irure dolor in reprehenderit in voluptate velit.
                    </li>
  </ul> */}
            </div>
        </div>


    </div>
</section>
<Footer />
</div>
    </div>
  )
}

export default TeamMember8
